import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { HomeChessTonImg } from "@/assets"
import { useModals } from "@/modals"
import { HomeMenuItem, IPlayTon } from ".."
import styles from "./PlayTon.module.scss"

export const PlayTon: FC<IPlayTon> = ({ className, ...rest }) => {
  const { t } = useTranslation()
  const { openModal } = useModals()

  const handleClick = () => {
    openModal("tonRooms")
    // openModal("findTonMatch")
  }

  return (
    <HomeMenuItem
      className={clsx(styles.PlayTon, className)}
      classNameContent={clsx(styles.PlayTon_content)}
      {...rest}
      title={t("playForTon.title")}
      button={{ title: t("selectBet"), styles: "green", onClick: handleClick }}
    >
      {t("playForTon.text")}
      <div className={clsx(styles.PlayTon_img)}>
        <img src={HomeChessTonImg} alt="home cards" />
      </div>
    </HomeMenuItem>
  )
}
